export const DATAGRAIL_CUSTOMER_ID =
  (typeof window !== 'undefined' && window.DATAGRAIL_CUSTOMER_ID) || '';

export const DATAGRAIL_CONTAINER_ID =
  (typeof window !== 'undefined' && window.DATAGRAIL_CONTAINER_ID) || '';

export const DATAGRAIL_LOADER_URL =
  DATAGRAIL_CUSTOMER_ID && DATAGRAIL_CONTAINER_ID
    ? `https://api.consentjs.datagrail.io/${DATAGRAIL_CUSTOMER_ID}/${DATAGRAIL_CONTAINER_ID}/consent-loader.js`
    : '';

export const DATAGRAIL_PERFORMANCE_CATEGORY = 'performance';
